interface IconDisplayProps {
  iconURL?: string;
  width?: number;
  height?: number;
  borderRadius?: string;
}

export const IconDisplay = ({ iconURL, width = 32, height = 32, borderRadius = '50%' }: IconDisplayProps) => {
  if (!iconURL) return <span>No image</span>;

  const cdnUrl = import.meta.env.VITE_CDN_URL;

  return (
    <img 
      src={iconURL}
      alt="Icon"
      style={{ 
        width,
        height,
        borderRadius,
        objectFit: 'contain'
      }}
      onError={(e) => {
        console.error('Image failed to load:', iconURL);
        e.currentTarget.style.display = 'none';
        e.currentTarget.insertAdjacentHTML('afterend', '<span>Failed to load</span>');
      }}
    />
  );
}; 